/* Import your third-Party plugins here */

import 'js/modernizr.js';
import 'js/jquery.js';
import 'js/perfect-scrollbar.js';
import 'js/l20n.js';

import "js/vendor/prism/prism.js";
import "js/vendor/select2/select2.js";
import 'js/vendor/timeline/timeline.js';
import "js/vendor/ion.rangeSlider/ion.rangeSlider.js";

import 'bower_components/d3/d3.js';
import "bower_components/c3/c3.js";
import 'bower_components/Chart.js/Chart.js';
import 'bower_components/trumbowyg/dist/trumbowyg.js';

import 'bower_components/dropzone/dist/min/dropzone.min.js';

import 'js/rubix.js';



// WEBPACK FOOTER //
// ./src/plugins.js